export default [
  // Router hệ thống
  {
    path: '/system',
    name: 'system',
    component: () => import('@/views/connect/ConnectMisaApp.vue'),
    meta: {},
  },

  // Quản lý người dùng
  {
    path: '/usermanagement',
    name: 'usermanagement',
    component: () => import(/* webpackChunkName:'di'*/ '@/views/system/usermanagement/UserManagementList.vue'),
    meta: {},
  },
  // Thông tin đơn vị
  {
    path: '/companyinfo',
    name: 'companyinfo',
    component: () => import('@/views/system/companyinfo/CompanyInfoList.vue'),
    meta: {},
  },

  // Vai trò quyền hạn
  {
    path: '/role/:key?',
    name: 'role',
    component: () => import(/* webpackChunkName:'di'*/ '@/views/system/role/RoleList.vue'),
    meta: {},
  },

    // Bảo mật nâng cao
    {
      path: '/advanced-sercurity',
      name: 'advanced-sercurity',
      component: () => import(/* webpackChunkName:'di'*/ '@/views/system/advancedSercurity/advancedSercurityIndex.vue'),
      meta: {},
    },

  // Báo cáo nhanh
  {
    path: '/quickreport/:key?',
    name: 'quickreport',
    component: () => import(/* webpackChunkName:'di'*/ '@/views/system/quickReport/QuickReportDetail.vue'),
    meta: {},
  },
  // Router quản lý dữ liệu
  {
    path: '/data-management/:key?',
    name: 'data-management',
    component: () => import('@/views/system/dataManagement/DataManagementIndex.vue'),
    meta: {},
  },
  // Router tạo dữ liệu kế toán
  {
    path: '/data-management/create-data',
    name: 'create-data',
    component: () => import('@/views/system/dataManagement/CreateData.vue'),
    meta: {},
  },
  // Router tạo dữ liệu kế toán năm trước
  {
    path: '/data-management/create-data-prev-year',
    name: 'create-data-prev-year',
    component: () => import('@/views/system/dataManagement/CreateDataPrevYear.vue'),
    meta: {},
  },
  {
    path: '/data-management/create-data-prev-year/create-data-process',
    name: 'create-data-process',
    component: () => import('@/views/system/dataManagement/popup/CreateDatabaseFromOldDataProcessPopup.vue'),
    meta: {},
  },
  // Sắp xếp lại số chứng từ
  {
    path: 'system/sort-refNo',
    name: 'sort-refNo',
    component: () => import('@/views/system/sortRefNo/popup/SortRefNo.vue'),
    meta: {},
  },

  // Nghiệp vụ
  {
    path: '/business',
    name: 'business',
    component: () => import('@/views/system/business/BusinessIndex.vue'),
    meta: {},
  },
];
